import Image from "next/image";
import Link from "next/link";
import useDateLocale from "hooks/useDateLocale";
import { formatDistanceToNowStrict } from "date-fns";
import { CompactNewsCard } from "./new-news-card";
import { NewsListCardSummaryFragment } from "@graphql/generated/graphql";

interface ITrendingNowCardProps {
  news: NewsListCardSummaryFragment;
}

const TrendingNowCard: React.FunctionComponent<ITrendingNowCardProps> = ({
  news,
}) => {
  return (
    <Link href={`/news/${news.id}`} passHref>
      <a>
        <div className="px-4 md:hidden">
          <CompactNewsCard news={news} showPublisher={true} />
        </div>
        <div className="hidden px-4 md:block">
          <WideTrendingNowCard news={news} />
        </div>
      </a>
    </Link>
  );
};

const WideTrendingNowCard: React.FunctionComponent<ITrendingNowCardProps> = ({
  news,
}) => {
  const locale = useDateLocale();
  return (
    <div className="relative">
      <div className="flex flex-col space-y-4">
        <div className="flex flex-row space-x-4">
          <div
            className="relative -mt-1 h-8 w-14"
            style={{
              filter: "drop-shadow(1px 1px 8px rgba(147, 154, 188, 0.4)",
            }}
          >
            <Image
              className="rounded-lg"
              src={news.newsPublisher.imageUrl}
              alt={news.newsPublisher.name}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <p className="font-sen text-sm text-text-dark">
            {news.newsPublisher.name}
          </p>
        </div>
        <div
          className="relative -mt-1 h-[179px] w-full"
          style={{
            filter: "drop-shadow(1px 1px 8px rgba(147, 154, 188, 0.4)",
          }}
        >
          <Image
            className="rounded-lg"
            src={news.thumbnailUrl}
            alt={news.title}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <p className="font-poppins text-lg font-bold text-text-darkest hover:text-text-dark">
          {news.title}
        </p>
        <p className="font-sen text-xs text-text-lightest">
          {formatDistanceToNowStrict(new Date(news.pubDate), {
            locale,
            addSuffix: true,
          })}
        </p>
      </div>
    </div>
  );
};

export default TrendingNowCard;
